.grid-wrap {
	min-width: 0;
	width: 100%;
}

// Same colours as the header's "Search the docs" control.
.search-input {
	border-color: var(--surreal-border-default);
	background-color: var(--docs-card);

	@include light {
		border-color: var(--surreal-border-default);
		background-color: var(--mantine-color-white);
	}
}

.no-results {
	text-align: center;
	padding: 3rem 1rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
